import { Box, ToggleButtonGroup as MuiToggleButtonGroup } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const ToggleButtonContainer = styled(Box)`
  padding: 32px 40px 16px;
  width: 100%;

  @media (max-width: 1280px) {
    padding: 32px ${theme.spacing.small}px 16px;
  }
`

export const ToggleButtonGroup = styled(MuiToggleButtonGroup)`
  border-radius: 8px;
  background: ${theme.colors.btnSecondaryHoverBg};
  display: flex;
  padding: 2px;
  align-items: center;
  gap: 2px;
  align-self: stretch;
  height: 40px;

  .MuiToggleButton-root {
    border-radius: 6px;
    border: 1px solid transparent;
    background: transparent;
    color: ${theme.colors.textSecondary};
    font-family: Quicksand, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    width: 100%;
    text-transform: none;
    height: 36px;

    &.Mui-selected {
      border-radius: 6px;
      border: 1px solid ${theme.colors.legacy4e444b};
      background: ${theme.colors.legacy4e444b};
      color: ${theme.colors.cta};
    }
  }
`
